export const VIEW_COURSE_CONSTANTS = {
  viewCourseTemplate: "View Course Environment",
  backToLibrary: "Back to Library Management",
  expandAll: "Expand All",
  collapseAll: "Collapse All",
  edit: "Edit",
  generalDetails: "General Details",
  courseName: "Course Name :",
  description: "Description:",
  status: "Status :",
  lastModifiedBy: "Last Modified By :",
  lastModifiedDate: "Last Modified Date :",
  time: "Time :",
  days : "Days",
  duration: "Duration :",
  vappDetails: "vApp Details",
  associatedVappTemplate: "Associated vApp Template :",
  filterBy: "Filter by",
  templateNameFilter: "Name",
  noFiltersApplied: "No filters applied",
  SearchByName: "Search by Name",
  SearchByOsType: "Search by OS Type",
  osTypeFilter: "OS Type",
  BACK_LINK_URL: "/academy/viewCourseTemplates",
  resultsRange: (from: number, to: number, total: number) => `${from}-${to} of ${total}`,
   CONFIRM: "Confirm",
  CANCEL: "Cancel",
  DESCRIPTION:"Please note the following :",
  DESCRIPTION_1:"1) Malware signature provided by antivirus vendor periodically, needs to be updated from time to time.",
  DESCRIPTION_2:"2) Failure to install & update will result into system shut down in order to maintain overall security."
};